import config from '@app/config';

export const NFT_ASSET_VIDEO_FORMATS = ['mp4', 'mov', 'ogv', 'webm', 'gif'];

export const nftBlackListRegex = config.nftBlackListedDomains.length
    ? new RegExp(
          config.nftBlackListedDomains
              .map((blacklistUrl) => `http[s]?://([a-zA-Z0-9-.]+.)?${blacklistUrl}/(.*)`)
              .join('|'),
      )
    : undefined;

export function isBlackListed(url?: string) {
    if (!url) return false;

    return nftBlackListRegex ? nftBlackListRegex.test(url) : false;
}
